"use client"

import NextLink, { LinkProps } from 'next/link'
import { useSearchParams } from 'next/navigation'

const Link = (props: LinkProps & { children?: any, target?: any }) => {
  const searchParams = useSearchParams()

  return (
    <NextLink
      {...props}
      href={typeof props.href === "string"
        ? `${props.href}${props.href.includes('?') ? '&' : '?'}${searchParams.toString()}`
        : {
          ...props.href,
          search: props.href.search ? `${props.href.search}&${searchParams.toString()}` : searchParams.toString()
        }} />
  )
}

export default Link